export default "__VITE_ASSET__2727fd7c__"